import { useEffect, useState } from "react";

import { BreakPointStateType, GridProps } from "./types";

const Grid = ({ children, style, className, align, justify, onClick, gap, xs, sm, md, lg, xl }: GridProps) => {
  const [breakPointState, setBreakPointState] = useState<BreakPointStateType>(0);

  useEffect(() => {
    if (xs || sm || md || lg || xl) {
      const value = xs || sm || md || lg || xl;
      setBreakPointState(value);
    }
  }, [xs, sm, md, lg, xl, breakPointState]);

  const spicyStyles = `flex justify-${justify} items-${align} ` + className;

  return (
    <div
      className={spicyStyles}
      onClick={() => !!onClick && onClick()}
      style={{
        gap: `${gap}rem`,
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default Grid;
